import { findErrorMessage } from "./find-error-message";

export async function handleApiError(response: Response): Promise<void> {
  if (response.ok) return;

  let errorData: unknown;
  try {
    errorData = await response.json();
  } catch {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const error = new Error(findErrorMessage(errorData) ?? `Request failed with status ${response.status}`);
  error.cause = errorData;
  throw error;
}
